import React, { FC, useState, useEffect } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';

import { CustomSelectRenderProps } from './type';

export const CustomSelectRender: FC<CustomSelectRenderProps> = ({
  field,
  API,
  targerValue,
  setViewValue,
}) => {
  const { dataKey, treeId, bindId, label, value, isBindLabel, labelBindKey, labelBindLabel, labelModule, isFilter, dataType, prefilter, isMulti } = field?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  useEffect(() => {
    if (!targerValue && targerValue !== 0) {
      return;
    }
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 3000,
    };
    if (isFilter) {
      const otherFilter = dataType || prefilter || '';
      params.filter = otherFilter;
    } else {
      params.filter = '';
    }
    if (isBindLabel && labelModule && labelBindKey) {
      params.moduleID = labelModule;
      params.filter = `${labelBindKey} in ('${targerValue}')`;
      if (bindId) {
        params.namespaceID = bindId;
      }
    }
    getModuleRecordListCache(API?.FetchAPI, params.namespaceID, params.moduleID, params).then((res: any) => {
      const { set = [] } = res || {};
      const listData = set.map((r: any) => convert(r));
      const key = isBindLabel ? labelBindKey : value;
      const realLabel = isBindLabel ? labelBindLabel : label;
      if (isMulti) {
        const valueList = targerValue?.split(',');
        const returnData: any[] = [];
        valueList.forEach((val: any) => {
          const findDictItem = listData?.find((item: Record<any, any>) => item[key] == val) || {};
          returnData.push(findDictItem?.[realLabel] || val);
        });
        setRenderData(returnData.join(','));
      } else {
        // == 后端数据不统一，有的字段string,有的是number类型
        const findDictItem = listData?.find((item: Record<any, any>) => item[key] == targerValue) || {};
        setRenderData(findDictItem?.[realLabel] || targerValue);
      }
    });
  }, [targerValue]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default CustomSelectRender;
